import type { Snowflake } from "discord.js";
import { StringSelectMenuBuilder } from "discord.js";

export function makeStringSelect(
	custom_id: Snowflake,
): StringSelectMenuBuilder {
	return new StringSelectMenuBuilder().setCustomId(custom_id);
}
